var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon-menu",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "20px",
    width: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A6A6A6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.3,171.7c3.6,3.6,3.6,9.4,0,13L479,215.1c-3.6,3.6-9.4,3.6-13,0l-49.8-50.2l-49.8,50.2 c-3.6,3.6-9.4,3.6-13,0L323,184.8c-3.6-3.6-3.6-9.4,0-13l50.2-49.8L323,72.2c-3.6-3.6-3.6-9.4,0-13l30.3-30.3c3.6-3.6,9.4-3.6,13,0 l49.8,50.2L466,28.8c3.6-3.6,9.4-3.6,13,0l30.3,30.3c3.6,3.6,3.6,9.4,0,13L459.1,122L509.3,171.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.1,146.4H22C9.9,146.4,0,136.6,0,124.4v-5C0,107.4,9.9,97.5,22,97.5h261.1c12.1,0,21.9,9.8,21.9,21.9v5 C305,136.6,295.2,146.4,283.1,146.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490,330.8H22C9.8,330.8,0,321,0,308.8v-5c0-12.1,9.8-21.9,21.9-21.9H490c12.1,0,21.9,9.8,21.9,21.9v5 C512,321,502.2,330.8,490,330.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490,512H22C9.8,512,0,502.2,0,490.1v-5C0,473,9.8,463.2,22,463.2H490c12.1,0,21.9,9.8,21.9,21.9v5 C512,502.2,502.2,512,490,512z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1dbba173ae52946443c67fd60ff5fbd1.svg";
export { ForwardRef as ReactComponent };